/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./withdrawstat.vue?vue&type=template&id=8ede6136&scoped=true"
import script from "./withdrawstat.vue?vue&type=script&lang=js"
export * from "./withdrawstat.vue?vue&type=script&lang=js"
import style0 from "./withdrawstat.vue?vue&type=style&index=0&id=8ede6136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ede6136",
  null
  
)

export default component.exports